import React from "react";
import { mapCategoryToDataTable as mapData } from "./Helper";
import ReusableDndTable from "src/components/table/ReusableDndTable/ReusableDndTable";
import GetCategoryColumns from "./ColumnDefinition/CategoryColumn/GetCategoryColumns";

const CategoryTable = ({
  data,
  handleDelete,
  handleOpenPopup,
  handleDisplayHomeScreen,
  onDragEnd,
  status,
}) => {
  const columns = GetCategoryColumns({
    handleDelete,
    handleOpenPopup,
    handleDisplayHomeScreen,
    status,
  });

  return (
    <ReusableDndTable
      columns={columns}
      data={mapData(data)}
      maxHeight={520}
      onDragEnd={onDragEnd}
    />
  );
};

export default CategoryTable;
